import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import languageEN from "./locales/en/translate.json";
import languageES from "./locales/es/translate.json";

const locale = document.documentElement.lang;

i18n.use(initReactI18next).init({
  supportedLngs: ["en", "es"],
  resources: {
    en: languageEN,
    es: languageES,
  },
  /* default language when load the website in browser */
  lng: locale,
  /* When react i18next not finding any language to as default in browser */
  fallbackLng: "en",
  /* debugger For Development environment */
  debug: process.env.NODE_ENV === "development",
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
  react: {
    useSuspense: false,
    bindI18n: "languageChanged loaded",
    bindStore: "added removed",
    nsMode: "default",
  },
});

export default i18n;
